import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase";

const GetUsersIncludesInArray = async (UsersIds = []) => {
  try {
    let dataToReturn = [];
    for (let index = 0; index < UsersIds.length; index++) {
      const UsersCollection = doc(db, "Users", UsersIds[index]);

      const UsersSnapshot = await getDoc(UsersCollection);
      dataToReturn.push({
        ...UsersSnapshot.data(),
        id: UsersSnapshot.id,
      });
    }
    return dataToReturn;
  } catch (error) {
    console.log(error);
  }
};

export default GetUsersIncludesInArray;
